var exports = {};

function elasticInOut(t) {
  return t < 0.5 ? 0.5 * Math.sin(+13 * Math.PI / 2 * 2 * t) * Math.pow(2, 10 * (2 * t - 1)) : 0.5 * Math.sin(-13 * Math.PI / 2 * (2 * t - 1 + 1)) * Math.pow(2, -10 * (2 * t - 1)) + 1;
}

exports = elasticInOut;
export default exports;